export const MEYA_SCRIPT_URL = 'https://cdn.meya.ai/v2/orb.js'
export const MEYA_FONT_URL = 'https://cdn.meya.ai/font/inter.css'
export const MEYA_GRID_URL = 'https://grid.meya.ai'

export const PUSHD_WS_URL = 'wss://pushd.nextersglobal.com/'
export const RPC_PING_URL = 'https://heroes-an.nextersglobal.com/pong.gif'
export const STATIC_PING_URL = 'https://heroes-a.akamaihd.net/iframe/pong.gif'

export const BACKGROUND_LOW_RES_URL = 'https://imagestorage-a.akamaihd.net/sup/d691e795-6a45-4490-b39d-3dc44606746d.jpg'
export const BACKGROUND_HIGH_RES_URL = 'https://imagestorage-a.akamaihd.net/sup/08eec4ce-60db-4aef-942f-0522a7123e58.png'

export const CATEGORY_TILE_BACKGROUNDS = [
  {
    lowRes: 'https://imagestorage-a.akamaihd.net/sup/75c3a20a-ff5d-4857-a686-7a504af015ac.jpg',
    highRes: 'https://imagestorage-a.akamaihd.net/sup/6541e7d3-2ff7-4217-b6c6-0d9ac7c9398a.png'
  },
  {
    lowRes: 'https://imagestorage-a.akamaihd.net/sup/2ee2fcf1-67ae-4c2d-8fc5-8ab3acf74040.jpg',
    highRes: 'https://imagestorage-a.akamaihd.net/sup/05692016-393d-4552-bf45-df9717fab4e0.png'
  },
  {
    lowRes: 'https://imagestorage-a.akamaihd.net/sup/ae6b7f23-1fc7-4d34-a6fb-5a11e3b14db5.jpg',
    highRes: 'https://imagestorage-a.akamaihd.net/sup/f150ba0e-41e4-40c5-ad7c-eb082c9c0ab6.png'
  },
  {
    lowRes: 'https://imagestorage-a.akamaihd.net/sup/baf0e210-a2fb-4a9c-8137-c77277a3256a.jpg',
    highRes: 'https://imagestorage-a.akamaihd.net/sup/59677855-819e-4e6f-bcf7-86724b6e7262.png'
  },
  {
    lowRes: 'https://imagestorage-a.akamaihd.net/sup/16c5191b-42eb-439a-93cc-a64b7e4d17d2.jpg',
    highRes: 'https://imagestorage-a.akamaihd.net/sup/ff39e431-b23f-442b-b3e7-a46a21dc4854.png'
  }
]
